import { Helmet } from "react-helmet-async";
// @mui
import { Container } from "@mui/material";
import Document from "src/components/Document/Document";
// ----------------------------------------------------------------------

export default function CSODocument() {
  return (
    <>
      <Helmet>
        <title> CSODocument </title>
      </Helmet>

      <Container maxWidth="xl">
        <Document Role="CSO" />
      </Container>
    </>
  );
}
